import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import { useParams, useNavigate } from "react-router-dom";
import ConfigurationService from "../../services/ConfigurationService";
import PanelPaciente from "../../components/formulario/panel-paciente";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Stack,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import PanelMedico from "../../components/formulario/panel-medico";
import PanelReceta from "../../components/formulario/panel-receta";
import CustomDialog from "../../components/custom-dialog";
import FormAddMedicamento from "../../components/formulario/form-add-medicamento";
import FormEditMedicamento from "../../components/formulario/form-edit-medicamento";
import CircularProgress from "@mui/material/CircularProgress";
import PanelDeleteMedicamento from "../../components/formulario/panel-delete-medicamento";
import PanelRecetaGenerada from "../../components/formulario/panel-receta-generada";
import RiseLoader from "react-spinners/RiseLoader";
import FormularioStore from "./Store";
import { observer } from "mobx-react";
import PanelConfiguracionMedico from "../../components/formulario/panel-configuracion-medico";
import PanelShareRecetas from "../../components/formulario/panel-share-recetas";
import { theme } from "../../theme";
import IconButton from "@mui/material/IconButton";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import HistorialRecetas from "../../components/historial-recetas";
import { logoutDoctor } from "../../utils";
import ErrorPage from "./ErrorPage";

const Formulario = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [store] = useState(new FormularioStore(params.hash, navigate));
  const [hideBarLateral, setHideBarLateral] = useState(false);
  const [togglePanelRecord, setTogglePanelRecord] = React.useState(false);
  const [record, setRecord] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [severityMessage, setSeverityMessage] = React.useState("");
  const [openActionRecord, setOpenActionRecord] = React.useState(false);
  const [actionRecord, setActionRecord] = React.useState({
    data: null,
    action: null,
  });

  const [loadingModal, setLoadingModal] = React.useState(false);
  const [titleGoBack, setTitleGoBack] = React.useState("");
  const [loadingModalHistory, setLoadingModalHistory] = React.useState(false);
  const [openSisaModal, setOpenSisaModal] = React.useState(false);
  const [sisaData, setSisaData] = React.useState(null);
  const [loadingSisa, setLoadingSisa] = React.useState(false);

  const CHARACTER_LIMIT = 100; // Límite de caracteres
  const [error, setError] = React.useState("");
  const [emailValue, setEmailValue] = React.useState("");

  const handleChange = (event) => {
    const newValue = event.target.value;
    setEmailValue(newValue);

    if (!validateEmail(newValue)) {
      setError("Por favor, introduce un email válido.");
    } else {
      setError("");
    }
  };

  const handleResetValue = (value) => {
    setEmailValue(value);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // Nuevo estado para errores de validación
  const [validationErrors, setValidationErrors] = useState(null);

  useEffect(() => {
    store.fetchData();
  }, []);

  const validateRequiredData = () => {
    const missingFields = [];

    const checkObjectProperties = (obj, prefix = "") => {
      if (!obj) return;

      Object.entries(obj).forEach(([key, value]) => {
        if (
          (prefix === "medico" && key === "medicoId") ||
          (prefix === "paciente" && key === "pacienteId") ||
          (prefix === "paciente" && key === "plan")
        ) {
          return;
        }

        const propPath = prefix ? `${prefix}.${key}` : key;

        if (value === null || value === undefined) {
          missingFields.push(`${propPath} no está definido`);
        } else if (typeof value === "object" && !Array.isArray(value)) {
          checkObjectProperties(value, propPath);
        }
      });
    };

    if (!store.medico) {
      missingFields.push("Datos del médico");
    } else if (!store.medico.medicoId) {
      missingFields.push("ID del médico");
    }

    if (!store.paciente) {
      missingFields.push("Datos del paciente");
    } else if (!store.paciente.pacienteId) {
      missingFields.push("ID del paciente");
    }

    if (!store.dataForm) missingFields.push("Configuración del formulario");
    if (!store.estilos) missingFields.push("Estilos de la aplicación");
    if (!store.sectionsEnabled)
      missingFields.push("Configuración de secciones");

    try {
      if (store.medico) checkObjectProperties(store.medico, "medico");
      if (store.paciente) checkObjectProperties(store.paciente, "paciente");
      if (store.dataForm) checkObjectProperties(store.dataForm, "dataForm");
      if (store.estilos) checkObjectProperties(store.estilos, "estilos");
      if (store.sectionsEnabled)
        checkObjectProperties(store.sectionsEnabled, "sectionsEnabled");

      if (store.urlCallback === undefined)
        missingFields.push("URL de callback");
    } catch (error) {
      missingFields.push(`Error inesperado: ${error.message}`);
    }

    return missingFields.length > 0 ? missingFields : null;
  };

  useEffect(() => {
    if (
      !store.loadingConfig &&
      store.sessionchecked &&
      !store.openSessionExpired
    ) {
      const missingFields = validateRequiredData();
      if (missingFields) {
        setValidationErrors(missingFields);
      } else {
        setValidationErrors(null);
      }
    }
  }, [store.loadingConfig, store.openSessionExpired]);

  useEffect(() => {
    if (store.emailPaciente) {
      setEmailValue(store.emailPaciente);
    }
  }, [store.emailPaciente]);

  const handleTogglePanelRecord = async () => {
    if (!togglePanelRecord) {
      getRecord();
    } else {
      store.setOldRecipe = false;
      await store.duplicarReceta();
    }
    setTogglePanelRecord(!togglePanelRecord);
  };

  const showRecord = async () => {
    if (!togglePanelRecord) {
      getRecord();
    }
    setTogglePanelRecord(!togglePanelRecord);
  };

  const getRecord = async () => {
    setLoadingModalHistory(true);
    let data = await store.getRecord({
      appId: params.hash,
      medicoId: store.medico.medicoId,
      pacienteId: store.paciente.pacienteId,
    });
    setRecord(data);
    setLoadingModalHistory(false);
  };
  const actionModalRecord = (data, action) => {
    setActionRecord({
      data: data,
      action: action,
    });
    setOpenActionRecord(true);
  };

  const unsubscribeRecipe = async (recetaId, estado) => {
    if (estado !== "VIGENTE") {
      return;
    }
    setLoadingModal(true);
    const response = await store.unsubscribeRecipe(recetaId);
    if (response.status === "Ok") {
      setLoadingModal(false);
      getRecord();
      setOpenActionRecord(false);
      setMessage("Receta dada de Baja con Éxito");
      setSeverityMessage("success");
      setOpen(true);
    } else {
      setLoadingModal(false);
      setOpenActionRecord(false);
      setMessage("Ocurrio un Error al Intentar dar de Baja a la Receta");
      setSeverityMessage("error");
      setOpen(true);
    }
  };

  const getResendRecipe = async (recetaId, estado, hash) => {
    if (estado !== "VIGENTE") {
      return;
    }
    if (!emailValue || emailValue.trim() === "") {
      setError("Por favor, introduce un email válido.");
      return;
    }
    setLoadingModal(true);
    const response = await store.getResendRecipe(recetaId, emailValue, hash);
    if (response.status === "Ok" && response.result) {
      setLoadingModal(false);
      setOpenActionRecord(false);
      setMessage("Receta enviada con Éxito");
      setSeverityMessage("success");
      setOpen(true);
    } else {
      setLoadingModal(false);
      setOpenActionRecord(false);
      setMessage("Ocurrio un Error al Intentar Reenviar la Receta");
      setSeverityMessage("error");
      setOpen(true);
    }
  };

  const createRecipeWithOldRecipe = async (recipe) => {
    setOpenActionRecord(false);
    setTogglePanelRecord(false);
    store.setOldRecipe = true;
    store.oldRecipe = recipe;
    await store.duplicarReceta();
  };

  useEffect(() => {
    if (
      store.recetasIds.length === 0 &&
      !store.panelConfiguracionMedico &&
      togglePanelRecord
    ) {
      setTitleGoBack("GENERAR RECETA");
    } else if (
      store.recetasIds.length > 0 &&
      !store.panelConfiguracionMedico &&
      togglePanelRecord
    ) {
      setTitleGoBack("GENERAR RECETA");
    } else {
      setTitleGoBack("");
    }
  }, [togglePanelRecord]);

  const handleClose = () => {
    setOpen(false);
  };

  // La verificación SISA es OBLIGATORIA cuando el estado es PENDIENTE: en ese
  // caso el modal no puede cerrarse ni cancelarse hasta confirmar la verificación.
  const estadoSisaPendiente = sisaData?.estado?.toUpperCase() === "PENDIENTE";

  // El cierre del modal queda bloqueado si la verificación es obligatoria
  // (PENDIENTE) o si el backend prohíbe operar y pide bloquear.
  const bloquearCierreSisa =
    estadoSisaPendiente ||
    (sisaData?.acciones?.permitirOperar === false &&
      sisaData?.acciones?.bloquear === true);

  // Solo se puede confirmar si el backend permite operar: un PENDIENTE con
  // permitirOperar=false (matrícula no existente en SISA) no es verificable.
  const puedeConfirmarSisa =
    sisaData?.acciones?.permitirOperar !== false &&
    (estadoSisaPendiente || sisaData?.datos?.debeVerificarSisa === true);

  const cerrarModalSisa = () => {
    setOpenSisaModal(false);
    setShouldCheckSisa(false);
    // Marcar que el modal fue cerrado manualmente
    setModalWasClosed(true);
  };

  const handleCloseSisaModal = () => {
    if (loadingSisa) return;

    // No permitir cerrar si la verificación es obligatoria.
    if (bloquearCierreSisa) {
      return;
    }

    cerrarModalSisa();
  };

  const handleConfirmSisa = async () => {
    // En PENDIENTE no exigimos codigoRefEps: el endpoint ConfirmaSisa solo usa
    // idMedico + confirmado, así el médico puede completar la verificación.
    if (
      (!sisaData?.datos?.codigoRefEps && !estadoSisaPendiente) ||
      !store.medico?.medicoId
    ) {
      setMessage("Datos de médico incompletos o no disponibles");
      setSeverityMessage("error");
      setOpen(true);
      return;
    }

    try {
      setLoadingSisa(true);

      // 1. Llamada a confirmSisa
      const confirmResponse = await ConfigurationService.confirmSisa({
        idMedico: store.medico?.medicoId,
        confirmado: true,
        hash: sessionStorage.getItem("tokenByHash"),
      });

      if (confirmResponse?.status === "Ok") {
        // 2. Si la confirmación fue exitosa, consultar estado actualizado
        const consultaResponse = await ConfigurationService.consultaSisa(
          sessionStorage.getItem("tokenByHash"),
          store.medico?.medicoId
        );

        if (consultaResponse?.result) {
          const result = consultaResponse.result;

          // 3. Actualizar el estado con la respuesta más reciente
          const formattedSisaData = {
            estado: result.estado,
            mensaje: result.mensaje || "Verificación exitosa",
            datos:
              result.datos === null
                ? null
                : {
                    matricula: result.datos?.matricula || null,
                    dniMasked: result.datos?.dniMasked || null,
                    iniciales: result.datos?.iniciales || null,
                    debeVerificarSisa: result.datos?.debeVerificarSisa ?? false,
                    codigoRefEps: result.datos?.codigoRefEps || null,
                  },
            acciones: {
              permitirOperar: result.acciones?.permitirOperar ?? true,
              bloquear: result.acciones?.bloquear ?? false,
              mostrarPopUpNuevamente:
                result.acciones?.mostrarPopUpNuevamente ?? false,
            },
          };

          setSisaData(formattedSisaData);
        }

        // Se cierra directo: handleCloseSisaModal todavía ve el estado PENDIENTE
        // de este render y bloquearía el cierre aunque la verificación ya se hizo.
        cerrarModalSisa();
        setMessage("Verificación SISA confirmada exitosamente");
        setSeverityMessage("success");
        setOpen(true);
      } else {
        throw new Error(
          confirmResponse.result?.mensaje || "Error en la confirmación SISA"
        );
      }
    } catch (error) {
      console.error("Error en handleConfirmSisa:", error);
      setMessage(error?.message || "Error al confirmar en SISA");
      setSeverityMessage("error");
      setOpen(true);
    } finally {
      setLoadingSisa(false);
    }
  };

  const [shouldCheckSisa, setShouldCheckSisa] = useState(true);
  const [modalWasClosed, setModalWasClosed] = useState(false);

  React.useEffect(() => {
    const checkSisa = async () => {
      if (!shouldCheckSisa || openSisaModal || loadingSisa || modalWasClosed) {
        return;
      }

      try {
        setShouldCheckSisa(false);
        const response = await ConfigurationService.consultaSisa(
          sessionStorage.getItem("tokenByHash"),
          store.medico?.medicoId
        );

        if (!response?.result) {
          throw new Error("No se recibió respuesta válida de SISA");
        }

        const result = response.result;
        const formattedSisaData = {
          estado:
            result.estado === "NO_ENCONTRADO"
              ? "El Médico no se encuentra registrado en SISA"
              : result.estado,
          mensaje:
            result.mensaje ||
            (result.estado === "NO_ENCONTRADO"
              ? "No se encontraron datos del médico registrados en SISA"
              : "No hay información disponible"),
          datos:
            result.datos === null
              ? null
              : {
                  matricula: result.datos?.matricula || null,
                  dniMasked: result.datos?.dniMasked || null,
                  iniciales: result.datos?.iniciales || null,
                  debeVerificarSisa: result.datos?.debeVerificarSisa ?? true,
                  codigoRefEps: result.datos?.codigoRefEps || null,
                },
          acciones: {
            permitirOperar: result.acciones?.permitirOperar ?? false,
            bloquear: result.acciones?.bloquear ?? false,
            mostrarPopUpNuevamente:
              result.acciones?.mostrarPopUpNuevamente ?? true,
          },
        };

        // Si el estado es NO_ENCONTRADO o los datos son null, asegurar que los datos sean null
        if (result.estado === "NO_ENCONTRADO" || result.datos === null) {
          formattedSisaData.datos = null;
        }

        setSisaData(formattedSisaData);

        if (store.medico) {
          // Determinar el estado del médico basado en la respuesta
          const nuevoEstadoMedico = result.estado;

          // Limpiar los datos del SISA cuando datos es null
          // Primero, siempre limpiar todos los datos relacionados con SISA
          store.medico = {
            ...store.medico,
            estadoSisa: nuevoEstadoMedico,
            codigoRefEps: null,
            fechaConfirmacionSisa: null,
            matriculaSisa: null,
            debeVerificarSisa: true,
          };

          // Solo si hay datos válidos y no son nulos, actualizarlos
          if (result.datos && Object.keys(result.datos).length > 0) {
            store.medico = {
              ...store.medico,
              codigoRefEps: result.datos.codigoRefEps || null,
              matriculaSisa: result.datos.matricula || null,
              debeVerificarSisa: result.datos.debeVerificarSisa ?? true,
            };
          }
        }

        if (result.acciones?.mostrarPopUpNuevamente && !modalWasClosed) {
          setOpenSisaModal(true);
        }
      } catch (error) {
        if (!openSisaModal && !modalWasClosed) {
          setMessage(error.message || "Error al consultar SISA");
          setSeverityMessage("error");
          setOpen(true);
        }
      }
    };

    if (store.medico && shouldCheckSisa) {
      checkSisa();
    }
  }, [store.medico, shouldCheckSisa, modalWasClosed]);

  return (
    <>
      {/* Modal de SISA - siempre presente en el DOM */}
      <Dialog
        open={openSisaModal}
        onClose={bloquearCierreSisa ? null : handleCloseSisaModal}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        disableBackdropClick={bloquearCierreSisa}
      >
        <DialogTitle>Verificación SISA</DialogTitle>
        <DialogContent>
          {sisaData && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" color="error" gutterBottom>
                Estado: {sisaData.estado}
              </Typography>
              <Typography variant="body1" gutterBottom>
                {sisaData.mensaje}
              </Typography>
              {sisaData.datos ? (
                <Box
                  sx={{
                    mt: 2,
                    backgroundColor: "#f5f5f5",
                    p: 2,
                    borderRadius: 1,
                  }}
                >
                  <Typography variant="subtitle2" gutterBottom>
                    Datos del médico:
                  </Typography>
                  <Typography variant="body2">
                    Matrícula: {sisaData.datos.matricula || "No disponible"}
                  </Typography>
                  <Typography variant="body2">
                    DNI: {sisaData.datos.dniMasked || "No disponible"}
                  </Typography>
                  <Typography variant="body2">
                    Iniciales: {sisaData.datos.iniciales || "No disponible"}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {!bloquearCierreSisa && (
            <Button
              onClick={handleCloseSisaModal}
              color="inherit"
              disabled={loadingSisa}
              sx={{
                "&.Mui-disabled": {
                  color: "rgba(0, 0, 0, 0.26)",
                },
              }}
            >
              Cancelar
            </Button>
          )}
          {puedeConfirmarSisa && (
              <Button
                onClick={handleConfirmSisa}
                variant="contained"
                color="primary"
                disabled={loadingSisa}
                startIcon={loadingSisa ? <CircularProgress size={20} /> : null}
              >
                Confirmar y Continuar
              </Button>
            )}
        </DialogActions>
      </Dialog>

      {/* Modal de sesión expirada */}
      {store.openSessionExpired && (
        <Dialog open={store.openSessionExpired}>
          <DialogTitle>Sesión expirada</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tu sesión expiró. Por favor ingrese su número de matrícula para
              poder reestablecerla.
            </DialogContentText>
            <TextField
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              autoFocus
              onChange={(value) => store.setDocumentoMedico(value)}
              margin="dense"
              id="dni"
              label="Número de matrícula"
              type="number"
              fullWidth
              variant="standard"
            />
            {store.errorRenovar && (
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: "400",
                  textAlign: "center",
                  color: "red",
                }}
              >
                {store.errorRenovar}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                store.handleCloseSessionExpired();
                logoutDoctor();
                navigate("/");
              }}
            >
              Cancelar
            </Button>
            <Button
              disabled={
                !store.valueDni ||
                store.valueDni === "" ||
                store.valueDni.length < 4
              }
              onClick={async () => {
                try {
                  // Primero renovamos la sesión
                  await store.renovarSesion();

                  // Si la renovación fue exitosa (no hay error en store.errorRenovar)
                  if (!store.errorRenovar) {
                    // Consultamos SISA
                    const sisaResponse =
                      await ConfigurationService.consultaSisa(
                        sessionStorage.getItem("tokenByHash"),
                        store.medico?.medicoId
                      );

                    if (sisaResponse?.result) {
                      const result = sisaResponse.result;

                      // Formateamos los datos de SISA
                      const formattedSisaData = {
                        estado:
                          result.estado === "NO_ENCONTRADO"
                            ? "El Médico no se encuentra registrado en SISA"
                            : result.estado,
                        mensaje:
                          result.mensaje ||
                          (result.estado === "NO_ENCONTRADO"
                            ? "No se encontraron datos del médico registrados en SISA"
                            : "No hay información disponible"),
                        datos: result.datos,
                        acciones: {
                          permitirOperar:
                            result.acciones?.permitirOperar ?? false,
                          bloquear: result.acciones?.bloquear ?? false,
                          mostrarPopUpNuevamente:
                            result.acciones?.mostrarPopUpNuevamente ?? true,
                        },
                      };

                      // Actualizamos el estado con los datos de SISA
                      setSisaData(formattedSisaData);

                      // Mostramos el modal de SISA si es necesario
                      if (result.acciones?.mostrarPopUpNuevamente) {
                        setOpenSisaModal(true);
                      }
                    }
                  }
                } catch (error) {
                  console.error(
                    "Error al consultar SISA después de renovar sesión:",
                    error
                  );
                  // Aquí podrías mostrar un mensaje de error si lo deseas
                  setMessage("Error al verificar estado SISA");
                  setSeverityMessage("error");
                  setOpen(true);
                }
              }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Página de error si hay errores de validación */}
      {validationErrors &&
        !store.openSessionExpired &&
        store.sessionchecked && <ErrorPage missingData={validationErrors} />}

      <CustomDialog
        title={"Eliminar medicamento"}
        open={store.showDialogDeleteMedicamento}
        estilos={store.estilos}
        customStyle={{
          padding: "10px 20px",
          [theme.breakpoints.up("sm")]: {
            width: "640px",
          },
        }}
        onClose={() => store.setShowDialogDeleteMedicamento(false)}
      >
        <PanelDeleteMedicamento
          onClick={store.executeAction}
          medicamento={store.productSelected}
          estilos={store.estilos}
          borrado={store.borrado}
          onClose={store.setShowDialogDeleteMedicamento}
        />
      </CustomDialog>
      <CustomDialog
        title={"Compartir recetas"}
        open={store.showDialogShareRecipes}
        estilos={store.estilos}
        customStyle={{
          padding: "10px 20px",
          [theme.breakpoints.up("sm")]: {
            width: "640px",
          },
        }}
        onClose={() => store.setShowDialogShareRecipes(false)}
      >
        <PanelShareRecetas
          onClick={store.executeAction}
          estilos={store.estilos}
          onClose={store.setShowDialogShareRecipes}
          email={store.emailPaciente}
          onChange={handleChange}
          loading={store.loadingSendEmail}
          enviado={store.emailEnviado}
          emailStore={store.emailPaciente}
          handleReset={handleResetValue}
          validateEmail={validateEmail}
        />
      </CustomDialog>
      <CustomDialog
        title={"Editar medicamento"}
        customStyle={{
          padding: "10px 20px 15px 20px",
        }}
        open={store.showDialogEditMedicamento}
        estilos={store.estilos}
        onClose={() => store.setShowDialogEditMedicamento(false)}
      >
        <FormEditMedicamento
          marcas={store.marcas}
          marcaSeleccionada={store.marcaSeleccionada}
          drogas={store.drogas}
          drogaSeleccionada={store.drogaSeleccionada}
          imprimirCodigo={store.imprimirCodigoByMed}
          onInputChangeMedicamentos={store.onInputChangeMedicamentos}
          seleccionarMedicamento={store.seleccionarMedicamento}
          loadingSearchMarca={store.loadingSearchMarca}
          loadingSearchDroga={store.loadingSearchDroga}
          presentaciones={store.presentaciones}
          presentacionSeleccionada={store.presentacionSeleccionada}
          cantidad={store.cantidad}
          original={store.medOriginal}
          generico={store.medGenerico}
          tratamiento={store.tratamiento}
          onChangePosologia={store.onChangePosologia}
          posologia={store.posologia}
          onClick={store.executeAction}
          diagnosticos={store.diagnosticosByMed}
          diagnostico={store.diagnosticoByMed}
          addDiagnostico={store.addDiagnosticoByMed}
          onInputChangeDiagnostico={store.onInputChangeDiagnosticoByMed}
          dataForm={store.dataForm}
          estilos={store.estilos}
          addMed={store.agregaMedicamento}
          maxCantidadEnvases={store.maxCantidadEnvases}
          existente={store.productoYaExistente}
        />
      </CustomDialog>
      <CustomDialog
        title={"Agregar medicamento"}
        customStyle={{
          padding: "10px 20px 15px 20px",
        }}
        open={store.showDialogAddMedicamento}
        estilos={store.estilos}
        onClose={() => store.setShowDialogAddMedicamento(false)}
      >
        <FormAddMedicamento
          marcas={store.marcas}
          marcaSeleccionada={store.marcaSeleccionada}
          drogas={store.drogas}
          drogaSeleccionada={store.drogaSeleccionada}
          imprimirCodigo={store.imprimirCodigoByMed}
          onInputChangeMedicamentos={store.onInputChangeMedicamentos}
          seleccionarMedicamento={store.seleccionarMedicamento}
          loadingSearchMarca={store.loadingSearchMarca}
          loadingSearchDroga={store.loadingSearchDroga}
          presentaciones={store.presentaciones}
          presentacionSeleccionada={store.presentacionSeleccionada}
          cantidad={store.cantidad}
          original={store.medOriginal}
          generico={store.medGenerico}
          tratamiento={store.tratamiento}
          onChangePosologia={store.onChangePosologia}
          posologia={store.posologia}
          onClick={store.executeAction}
          diagnosticos={store.diagnosticosByMed}
          diagnostico={store.diagnosticoByMed}
          addDiagnostico={store.addDiagnosticoByMed}
          onInputChangeDiagnostico={store.onInputChangeDiagnosticoByMed}
          dataForm={store.dataForm}
          estilos={store.estilos}
          addMed={store.agregaMedicamento}
          maxCantidadEnvases={store.maxCantidadEnvases}
          existente={store.productoYaExistente}
        />
      </CustomDialog>
      <Dialog
        open={openActionRecord}
        onClose={() => setOpenActionRecord(false)}
      >
        <DialogTitle>
          {actionRecord.action === "unsubscribeRecipe"
            ? "Baja de Receta"
            : actionRecord.action === "getResendRecipe"
            ? "Reenviar Receta"
            : "Crear Receta"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              minWidth: "425px",
            }}
          >
            {!loadingModal &&
              (actionRecord.action === "unsubscribeRecipe" ? (
                "¿Estás seguro de querer dar de baja la Receta?"
              ) : actionRecord.action === "getResendRecipe" ? (
                <>
                  <Box sx={{ padding: "20px", textAlign: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "0.95rem",
                        fontWeight: "400",
                        textAlign: "center",
                        color: store.estilos.colorTextSecondary,
                      }}
                    >
                      Se reenviará la Receta al siguiente Email, si no es el
                      correcto por favor modificalo.
                    </Typography>
                    <TextField
                      label="Email"
                      type="email"
                      inputProps={{
                        maxLength: CHARACTER_LIMIT,
                        pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
                      }}
                      value={emailValue}
                      helperText={`${
                        (emailValue || "").length
                      }/${CHARACTER_LIMIT} ${error ? `- ${error}` : ""}`}
                      onChange={handleChange}
                      margin="normal"
                      variant="outlined"
                      error={!!error}
                    />
                  </Box>
                </>
              ) : (
                "¿Estás seguro de querer crear una nueva Receta en base a la seleccionada?"
              ))}
          </DialogContentText>
          {loadingModal && (
            <Box
              sx={{
                width: "100%",
                backgroundColor: "white",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <Stack
                spacing={5}
                sx={{ alignItems: "center", justifyContent: "center" }}
              >
                <RiseLoader
                  color={store.estilos.backgroundColorPrimary}
                  loading={loadingModal}
                  size={17}
                />
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: "400",
                    textAlign: "center",
                    color: store.estilos.colorTextSecondary,
                  }}
                >
                  Procesando tu solicitud ....
                </Typography>
              </Stack>
            </Box>
          )}
        </DialogContent>
        {!loadingModal && (
          <DialogActions>
            <Button onClick={() => !loadingModal && setOpenActionRecord(false)}>
              Cancelar
            </Button>
            <Button
              disabled={error}
              onClick={() => {
                if (
                  actionRecord.action === "unsubscribeRecipe" &&
                  !loadingModal
                ) {
                  unsubscribeRecipe(
                    actionRecord.data.recetaId,
                    actionRecord.data.estado
                  );
                }
                if (
                  actionRecord.action === "getResendRecipe" &&
                  !loadingModal
                ) {
                  getResendRecipe(
                    actionRecord.data.recetaId,
                    actionRecord.data.estado,
                    actionRecord.data.hash
                  );
                  setEmailValue(store.emailPaciente);
                }
                if (
                  actionRecord.action === "createRecipeWithOldRecipe" &&
                  !loadingModal
                ) {
                  createRecipeWithOldRecipe(actionRecord.data);
                }
              }}
            >
              Aceptar
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {store.loadingConfig && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            padding: "50px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!store.loadingConfig &&
        store.estilos &&
        store.dataForm &&
        store.sectionsEnabled && (
          <>
            {store.sectionsEnabled.showHeaderSection && (
              <AppBar position="fixed" color={"default"}>
                <Container maxWidth="xl">
                  <Toolbar disableGutters>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Stack>
                        <Tooltip
                          title={
                            !hideBarLateral
                              ? "Ocultar datos del médico y del paciente"
                              : "Mostrar datos del médico y del paciente"
                          }
                        >
                          <IconButton
                            aria-label="close-open"
                            sx={{
                              backgroundColor: "#EEEEEE",
                              "&:hover": {
                                backgroundColor: "#EEEEEE",
                                opacity: 0.8,
                              },
                              width: "30px",
                              height: "30px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            onClick={() => setHideBarLateral(!hideBarLateral)}
                          >
                            {!hideBarLateral ? (
                              <KeyboardDoubleArrowLeftIcon
                                sx={{
                                  [theme.breakpoints.down("md")]: {
                                    display: "none",
                                  },
                                }}
                                color="#A4A4A4"
                              />
                            ) : (
                              <KeyboardDoubleArrowRightIcon
                                sx={{
                                  [theme.breakpoints.down("md")]: {
                                    display: "none",
                                  },
                                }}
                                color="#A4A4A4"
                              />
                            )}
                            {!hideBarLateral ? (
                              <KeyboardDoubleArrowUpIcon
                                sx={{
                                  [theme.breakpoints.up("md")]: {
                                    display: "none",
                                  },
                                }}
                                color="#A4A4A4"
                              />
                            ) : (
                              <KeyboardDoubleArrowDownIcon
                                sx={{
                                  [theme.breakpoints.up("md")]: {
                                    display: "none",
                                  },
                                }}
                                color="#A4A4A4"
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                      </Stack>
                      <Stack>
                        {store.estilos.logo && (
                          <img
                            src={store.estilos.logo}
                            height={"52px"}
                            alt="logo"
                          />
                        )}
                      </Stack>
                    </div>
                  </Toolbar>
                </Container>
              </AppBar>
            )}

            <Box
              sx={{
                display: "flex",
                flex: "1 1 auto",
                flexDirection: "column",
                width: "100%",
                paddingTop: store.sectionsEnabled.showHeaderSection
                  ? "68px"
                  : "0px",
                backgroundColor: "#EEEEEE",
              }}
            >
              <Grid container spacing={1}>
                {!store.loadingConfig &&
                  store.paciente &&
                  store.medico &&
                  !hideBarLateral &&
                  (store.sectionsEnabled.showMedicoSection ||
                    store.sectionsEnabled.showPacienteSection) &&
                  !store.panelConfiguracionMedico && (
                    <Grid item xs={12} sm={12} md={3}>
                      <Stack
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "7px",
                          boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2)",
                          margin: "5px",
                          padding: "10px",
                          filter:
                            "dropShadow(0px 1px 1px rgba(0, 0, 0, 0.14)) dropShadow(0px 1px 3px rgba(0, 0, 0, 0.12))",
                        }}
                      >
                        {store.sectionsEnabled.showPacienteSection && (
                          <PanelPaciente
                            paciente={store.paciente}
                            estilos={store.estilos}
                            showRecord={handleTogglePanelRecord}
                            titleGoBack={titleGoBack}
                          />
                        )}
                        {store.sectionsEnabled.showMedicoSection && (
                          <PanelMedico
                            medico={store.medico}
                            estilos={store.estilos}
                            onClick={store.openPanelConfiguracionMedico}
                            sisaData={sisaData}
                          />
                        )}
                      </Stack>
                    </Grid>
                  )}

                {store.loadingReceta && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={
                      (store.sectionsEnabled.showMedicoSection ||
                        store.sectionsEnabled.showPacienteSection) &&
                      !hideBarLateral
                        ? 9
                        : 12
                    }
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "white",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <Stack
                        spacing={5}
                        sx={{ alignItems: "center", justifyContent: "center" }}
                      >
                        <RiseLoader
                          color={store.estilos.backgroundColorPrimary}
                          loading={store.loadingReceta}
                          size={22}
                        />
                        <Typography
                          sx={{
                            fontSize: "0.95rem",
                            fontWeight: "400",
                            textAlign: "center",
                            color: store.estilos.colorTextSecondary,
                          }}
                        >
                          {store.textAccionReceta}
                        </Typography>
                      </Stack>
                    </Box>
                  </Grid>
                )}
                {!store.loadingConfig && !store.loadingReceta && (
                  <Grid
                    item
                    xs={12}
                    md={
                      !hideBarLateral &&
                      (store.sectionsEnabled.showMedicoSection ||
                        store.sectionsEnabled.showPacienteSection) &&
                      !store.panelConfiguracionMedico
                        ? 9
                        : 12
                    }
                  >
                    {store.panelConfiguracionMedico && (
                      <PanelConfiguracionMedico
                        medico={store.medico}
                        estilos={store.estilos}
                        onClick={store.saveConfiguracionMedico}
                      />
                    )}
                    {store.recetasIds.length === 0 &&
                      !store.panelConfiguracionMedico &&
                      !togglePanelRecord && (
                        <PanelReceta
                          dataForm={store.dataForm}
                          estilos={store.estilos}
                          diagnosticos={store.diagnosticos}
                          diagnostico={store.diagnostico}
                          onInputChange={store.onInputChange}
                          leyenda={store.leyenda}
                          onChangeLeyenda={store.onChangeLeyenda}
                          setDiagnostico={store.addDiagnostico}
                          imprimirCodigo={store.imprimirCodigo}
                          ocultarDatosPaciente={store.ocultarDatosPaciente}
                          posdatadas={store.posdatadas}
                          limitePosdatadas={
                            store.dataForm.cantidadRecetasPostdatadas
                          }
                          handleChangePostdatada={store.handleChangePostdatada}
                          cantidadRecetas={store.cantidadRecetas}
                          onClick={store.executeAction}
                          medicamentosReceta={store.medicamentosReceta}
                          tratamientoProlongado={store.tratamientoProlongado}
                          error={store.error}
                          sisaBloqueaPrescripcion={
                            !!sisaData &&
                            sisaData.acciones?.permitirOperar === false
                          }
                          urlCallback={store.urlCallback}
                        />
                      )}
                    {/*TODO - revisar el componente de la receta */}
                    {!store.isRefeched &&
                      store.recetasIds.length > 0 &&
                      !togglePanelRecord &&
                      !store.panelConfiguracionMedico && (
                        <PanelRecetaGenerada
                          estilos={store.estilos}
                          error={store.errorPostGeneracion}
                          recetasIds={store.recetasIds}
                          recetas={store.recetasGeneradas}
                          loading={store.loadingDownloadReceta}
                          onClick={store.executeAction}
                          urlCallback={store.urlCallback}
                          duplicarReceta={store.duplicarReceta}
                          tratamientoProlongado={store.tratamientoProlongado}
                        />
                      )}

                    {togglePanelRecord && !loadingModalHistory && (
                      <HistorialRecetas
                        showRecord={showRecord}
                        record={record}
                        setRecord={setRecord}
                        unsubscribeRecipe={actionModalRecord}
                        getResendRecipe={actionModalRecord}
                        createRecipeWithOldRecipe={actionModalRecord}
                      />
                    )}
                    {loadingModalHistory && (
                      <Box
                        sx={{
                          width: "100%",
                          backgroundColor: "white",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          marginTop: "20px",
                          height: "30vh",
                        }}
                      >
                        <Stack
                          spacing={5}
                          sx={{
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <RiseLoader
                            color={store.estilos.backgroundColorPrimary}
                            loading={loadingModalHistory}
                            size={17}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.95rem",
                              fontWeight: "400",
                              textAlign: "center",
                              color: store.estilos.colorTextSecondary,
                            }}
                          >
                            Cargando Historial....
                          </Typography>
                        </Stack>
                      </Box>
                    )}
                  </Grid>
                )}
              </Grid>
            </Box>
          </>
        )}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transitionDuration={500}
      >
        <Alert variant="outlined" severity={severityMessage}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default observer(Formulario);

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: "white",
    borderRadius: 7,
    boxShadow: "0px 2px 1px -1px rgba(0, 0, 0, 0.2)",
    margin: "5px",
    padding: "16px",
    filter:
      "dropShadow(0px 1px 1px rgba(0, 0, 0, 0.14)) dropShadow(0px 1px 3px rgba(0, 0, 0, 0.12))",
  },
}));
